import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

//global modules
import { helper } from './modules/helper';
import { settings } from './modules/settings';
import { player } from './modules/player';
import { cmsSettings } from './modules/cmsSettings';
import keyValueState from './modules/keyValueState';

// modules
import authStore from '../views/auth/auth-store';
import historyStore from '../views/history/history-store';
import accountVerificationStore from '../views/account-verification/account-verification-store';
import smsVerificationStore from '../views/account-verification/sms-verification-store';
import {
  depositStore,
  echeckStore,
  moneyGramStore,
  creditCardStore,
  claimBonusStore,
  onlineBankingStore,
  quickBitStore,
  netellerStore,
  skrillStore,
  gamecashStore,
  ewalletStore,
  storedDepositStore,
} from '../views/deposit/stores';
import {
  payoutStore,
  cryptoCurrencyStore,
  wireTransferStore,
  eCheckPayoutStore,
  onlineBankingPayoutStore,
  payrPayoutStore,
  skrillPayoutStore,
  netellerPayoutStore,
  speiPayoutStore,
  storedPayoutStore,
  toditoPayoutStore,
  vcreditosPayoutStore,
  ewalletPayoutStore,
  all4payPayoutStore,
} from '../views/payout/stores';
import { referStore, contactStore, bonusStore } from '../views/landing/stores';
import { betSlip } from '../views/sports/store/bet-slip-store';
import { betLines } from '../views/sports/store/bet-lines-store';
import { sportMenu } from '../views/sports/store/sports-menu-store';
import { propsStore } from '../views/sports/store/props-store';
import { openBetsStore } from '../views/sports/store/open-bets-store';
import { depositTicketStore } from '../views/sports/store/deposit-ticket-store';
import { freeWagerStore } from '../views/sports/store/free-wager-store';
import { clerkDepositStore } from '../views/clerk/stores';
import { clerkWagerStore } from '../views/clerk/stores';
import { clerkLoyaltyStore } from '../views/clerk/stores';
import { clerkPayoutRegisteredCustomerStore } from '../views/clerk/stores';
import { clerkPayoutDepositTicketStore } from '../views/clerk/stores';
import { casinoMenu } from '../views/casino/store/casino-menu-store';
import {
  statscoreComparisons,
  statscoreStandings,
  statscoreMatches,
  statscoreScorers,
  statscoreCards,
  statscoreStatics,
} from '../views/statscore/store';

export default new Vuex.Store({
  modules: {
    helper,
    settings,
    player,
    cmsSettings,
    keyValueState,
    depositStore,
    echeckStore,
    moneyGramStore,
    creditCardStore,
    gamecashStore,
    ewalletStore,
    claimBonusStore,
    onlineBankingStore,
    quickBitStore,
    netellerStore,
    skrillStore,
    authStore,
    historyStore,
    referStore,
    accountVerificationStore,
    smsVerificationStore,
    contactStore,
    bonusStore,
    betSlip,
    betLines,
    sportMenu,
    depositTicketStore,
    freeWagerStore,
    propsStore,
    openBetsStore,
    clerkDepositStore,
    clerkWagerStore,
    clerkLoyaltyStore,
    clerkPayoutRegisteredCustomerStore,
    clerkPayoutDepositTicketStore,
    payoutStore,
    cryptoCurrencyStore,
    wireTransferStore,
    eCheckPayoutStore,
    onlineBankingPayoutStore,
    payrPayoutStore,
    skrillPayoutStore,
    netellerPayoutStore,
    casinoMenu,
    toditoPayoutStore,
    speiPayoutStore,
    storedPayoutStore,
    vcreditosPayoutStore,
    statscoreComparisons,
    statscoreStandings,
    statscoreMatches,
    statscoreScorers,
    statscoreCards,
    statscoreStatics,
    all4payPayoutStore,
    ewalletPayoutStore,
    storedDepositStore,
  },
});
